class Storage {
  static cache = {};

  /*
   * 清空本地存储
   */
  static clear() {
    window.localStorage.clear();
  }
  /*
   * 设置某项本地存储
   */

  static setItem(key, data, expire) {
    if (!key || typeof window === 'undefined') return;

    const storage = window.localStorage;
    try {
      const dataTarget = {
        data,
        expire,
        createTime: Date.now()
      };
      const dataTargetStr = JSON.stringify(dataTarget || null);

      storage.setItem(key, dataTargetStr);
      this[key] = dataTargetStr;
    } catch (error) {
      // empty line
    }
  }

  /*
   * 获取某项本地存储
   */
  static getItem(key) {
    if (!key || typeof window === 'undefined') return null;

    const storage = window.localStorage;
    const json = this[key] || storage.getItem(key);
    if (json) {
      try {
        const { data, expire, createTime } = JSON.parse(json);

        if (expire > 0 && Date.now() > expire) {
          return null;
        }

        return data;
      } catch (err) {
        return null;
      }
    }
    return null;
  }

  /*
   * 获取某项本地存储
   */
  static getItem(key) {
    if (!key || typeof window === 'undefined') return null;
    const storage = window.localStorage;
    const json = this[key] || storage.getItem(key);
    if (json) {
      try {
        const { data, expire, createTime } = JSON.parse(json);

        if (expire > 0 && Date.now() > expire) {
          return null;
        }

        return data;
      } catch (err) {
        return null;
      }
    }
    return null;
  }

  /*
   * 获取某项本地存储
   */
  static getItemWithTime(key) {
    if (!key || typeof window === 'undefined') return null;
    const storage = window.localStorage;
    const json = this[key] || storage.getItem(key);
    if (json) {
      try {
        const { data, expire, createTime } = JSON.parse(json);

        if (expire > 0 && Date.now() > expire) {
          return null;
        }

        return {
          data,
          expire,
          createTime
        };
      } catch (err) {
        return null;
      }
    }
    return null;
  }

  /*
   * 删除某项本地存储
   */
  static removeItem(key) {
    if (!key) return;
    const storage = window.localStorage;
    storage.removeItem(key);
    delete this[key];
  }
}

export const storage = Storage;

export const EnumCacheKey = {
  // 是否支付
  'app/pay/has': 'app/pay/has',
  // 支付类型，1：支付弹窗，2：下载弹窗
  'app/pay/type': 'app/pay/type',
  // Sexy Chat 排队人数
  'app/queue/count': 'app/queue/count',
  //是否vip
  'app/user/isVip': 'app/user/isVip',
  // AI
  'app/ai/role': 'app/ai/role', // 角色记忆
  'app/ai/ask/count': 'app/ai/ask/count', // 提问次数
  'app/ai/image/count': 'app/ai/image/count', // 图片提问次数
  'app/ai/lover/count': 'app/ai/lover/count', // 颜色提问次数
  'app/ai/dailyboon/count': 'app/ai/dailyboon/count',
  'app/ai/lover/history': 'app/ai/lover/history',
  'app/ai/assistant/history': 'app/ai/assistant/history',

  'app/cache/autoreply': 'app/cache/autoreply', // 自动回复记录

  // 是否登录
  'app/haslogin': 'app/haslogin',
  // 用户邮箱
  'app/user/email': 'app/user/email',
  // 用户id
  'app/user/uid': 'app/user/uid',

  // 终身卡数量
  'app/vip/only': 'app/vip/only',
  'app/vip/only3': 'app/vip/only3',
  'app/vip/only2': 'app/vip/only2',

  // 用户功能操作
  'app/dots/func': 'app/user/func',

  // 福利详情
  'app/boon/detail': 'app/boon/detail',

  // 每日福利最新一条的发送日期
  'app/boon/date': 'app/boon/date',

  //当前正在聊天的角色
  'app/chat/role': 'app/chat/role',

  //最近聊天过的角色
  'app/cache/recentChat': 'app/cache/recentChat',

  'app/auth': 'app/auth',

  //多域名配置
  'app/web/config': 'app/web/config',

  //是否有点卡
  'app/pay/hasPoints': 'app/pay/hasPoints',

  // 用户地区策略分组
  'user/area/group': 'user/area/group',

  'app/chat/firstRole': 'app/chat/firstRole',
  //服务器时间戳
  'app/timeStamp': 'app/timeStamp',
  //用户本地时间和我们服务器之间的差值
  'app/timeDiff': 'app/timeDiff'
};

export default storage;
